import { Id } from '@nextforce/api'

const keys = {
  all: ['weekly_summary'],
  helper: () => [...keys.all, 'helper'],
  store: (storeId: Id) => [...keys.all, 'store', storeId],
}

export default keys
